// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail_detail__2hEvz","pre":"detail_pre__uXNiN"};